module.exports = {
  colors: {
    // Values are the Penpot "Bora (Sark Shipping)" tokens (global.*, colorsref color.*).
    // TL step -> Penpot step: darkest 900, darker 800, dark 700, base 600, medium-light 500,
    // medium-lighter 400, normal-light 300, normal-lighter 200, very-light 100.
    // Penpot itself has neutral-500 = neutral-400 and neutral-900 = neutral-800; kept as is.

    'base-darkest': '#040913', // primary-900
    'base-darker': '#0B1B3A', // primary-800
    'base-dark': '#122D60', // primary-700
    'primary-base': '#324975', // primary-600 = color.body.header
    'base-medium-light': '#51658A', // primary-500
    'base-medium-lighter': '#7181A0', // primary-400
    'base-normal-light': '#909DB5', // primary-300
    'base-normal-lighter': '#B0B9CA', // primary-200
    'base-very-light': '#D0D5DF', // primary-100
    'base-lightest': '#D0D5DF', // primary-100 (Penpot has no step lighter than 100)
    interactive: '#0071BC', // accent-500 = color.ui.button.primary.bg, color.ui.button.flow.continue
    'base-muted': '#7181A0', // primary-400; Penpot has no muted token

    'secondary-darkest': '#211910', // secondary-900
    'secondary-darker': '#423221', // secondary-800
    'secondary-dark': '#644A31', // secondary-700
    secondary: '#856342', // secondary-600
    'secondary-medium-light': '#A67C52', // secondary-500
    'secondary-medium-lighter': '#B89675', // secondary-400
    'secondary-normal-light': '#CAB097', // secondary-300
    'secondary-normal-lighter': '#DBCBBA', // secondary-200
    'secondary-very-light': '#EDE5DC', // secondary-100
    'secondary-lightest': '#EDE5DC', // secondary-100 (Penpot has no step lighter than 100)

    'tertiary-darkest': '#111A18', // tertiary-900
    'tertiary-darker': '#213330', // tertiary-800
    'tertiary-dark': '#324D48', // tertiary-700
    tertiary: '#426660', // tertiary-600
    'tertiary-medium-light': '#538078', // tertiary-500
    'tertiary-medium-lighter': '#759993', // tertiary-400
    'tertiary-normal-light': '#98B3AE', // tertiary-300
    'tertiary-normal-lighter': '#BACCC9', // tertiary-200
    'tertiary-very-light': '#DDE6E4', // tertiary-100
    'tertiary-lightest': '#DDE6E4', // tertiary-100 (Penpot has no step lighter than 100)

    'complimentary-darkest': '#222A31', // complementary-900
    'complimentary-darker': '#3D4C57', // complementary-800
    'complimentary-dark': '#586E7E', // complementary-700
    complimentary: '#738FA5', // complementary-600
    'complimentary-medium-light': '#8EB1CC', // complementary-500
    'complimentary-medium-lighter': '#A9D3F3', // complementary-400
    'complimentary-normal-light': '#C0DFF6', // complementary-300
    'complimentary-normal-lighter': '#D7EAF9', // complementary-200
    'complimentary-very-light': '#EEF6FD', // complementary-100
    'complimentary-lightest': '#EEF6FD', // complementary-100 (Penpot has no step lighter than 100)

    'accent-darkest': '#001726', // accent-900
    'accent-darker': '#002D4B', // accent-800
    'accent-dark': '#004471', // accent-700
    accent: '#005A96', // accent-600
    'accent-medium-light': '#0071BC', // accent-500
    'accent-medium-lighter': '#338DC9', // accent-400
    'accent-normal-light': '#66AAD7', // accent-300
    'accent-normal-lighter': '#99C6E4', // accent-200
    'accent-very-light': '#CCE3F2', // accent-100
    'accent-lightest': '#CCE3F2', // accent-100 (Penpot has no step lighter than 100)

    'neutral-darkest': '#4B4A48', // neutral-900
    'neutral-darker': '#4B4A48', // neutral-800
    'neutral-dark': '#646360', // neutral-700
    neutral: '#7D7C79', // neutral-600
    'neutral-medium-light': '#AEADA9', // neutral-500
    'neutral-medium-lighter': '#AEADA9', // neutral-400
    'neutral-normal-light': '#C7C6C1', // neutral-300
    'neutral-normal-lighter': '#E0DED9', // neutral-200
    'neutral-very-light': '#F5F5F5', // neutral-100
    'neutral-lightest': '#F5F5F5', // neutral-100 (Penpot has no step lighter than 100)
    'neutral-ultra-lightest': '#F5F5F5', // neutral-100
    'neutral-background-profile': '#F5F5F5', // neutral-100
    'card-title': '#4B4A48', // = neutral-darkest, as in TL
    'card-desc': '#4B4A48', // = neutral-darker, as in TL
    'card-label': '#4B4A48', // = neutral-darker, as in TL
    'card-value': '#AEADA9', // = neutral-medium-lighter, as in TL
    'card-quantity': '#4B4A48', // = neutral-darker, as in TL
    'card-subtotal': '#324975', // = primary-base, "cost"

    'success-darkest': '#091910', // success-900
    'success-darker': '#153A25', // success-800
    'success-dark': '#225C3B', // success-700
    success: '#2E7D50', // success-600
    'success-medium-light': '#4F926C', // success-500
    'success-medium-lighter': '#71A788', // success-400
    'success-normal-light': '#92BBA4', // success-300
    'success-normal-lighter': '#B4D0C0', // success-200
    'success-very-light': '#D5E5DC', // success-100
    'success-lightest': '#D5E5DC', // success-100 (Penpot has no step lighter than 100)

    'warning-darkest': '#2F2804', // warning-900
    'warning-darker': '#544807', // warning-800
    'warning-dark': '#79690A', // warning-700
    warning: '#9E890E', // warning-600
    'warning-medium-light': '#C4A911', // warning-500
    'warning-medium-lighter': '#E9C914', // warning-400
    'warning-normal-light': '#EFD753', // warning-300
    'warning-normal-lighter': '#F5E691', // warning-200
    'warning-very-light': '#FBF4D0', // warning-100
    'warning-lightest': '#FBF4D0', // warning-100 (Penpot has no step lighter than 100)

    'error-darkest': '#230402', // error-900
    'error-darker': '#520904', // error-800
    'error-dark': '#800E06', // error-700
    error: '#AF1308', // error-600
    'error-medium-light': '#BC3930', // error-500
    'error-medium-lighter': '#C95F57', // error-400
    'error-normal-light': '#D5847F', // error-300
    'error-normal-lighter': '#E2AAA6', // error-200
    'error-very-light': '#EFD0CE', // error-100
    'error-lightest': '#EFD0CE', // error-100 (Penpot has no step lighter than 100)

    'info-darkest': '#082431', // info-900
    'info-darker': '#104861', // info-800
    'info-dark': '#186D92', // info-700
    info: '#2091C2', // info-600
    'info-medium-light': '#28B5F3', // info-500
    'info-medium-lighter': '#53C4F5', // info-400
    'info-normal-light': '#7ED3F8', // info-300
    'info-normal-lighter': '#A9E1FA', // info-200
    'info-very-light': '#D4F0FD', // info-100

    'frozen-ice': '#28B5F3', // info-500, as TL frozen-ice = TL info-medium-light
    hazard: '#9E890E', // warning-600, the hazardous-goods icon colour in cargo-sark
    'alert-dark': '#800E06', // error-700
    'alert-base': '#AF1308', // error-600
    'alert-lightest': '#EFD0CE', // error-100

    // Text and icons on an accent (interactive) background, Penpot token color.ui.switcher.text.active
    'accent-foreground': '#E8F4FF',
  },
  backgroundPosition: {
    '20-center': '20% center',
  },
  backgroundSize: {
    cover: 'cover',
  },
  backgroundRepeat: {
    'no-repeat': 'no-repeat',
  },
  backgroundAttachment: {
    fixed: 'fixed',
  },
  extend: {
    fontFamily: {
      sans: ['var(--font-poppins)', 'ui-sans-serif', 'system-ui', 'sans-serif'],
    },
    // ticket card
    fontSize: {
      'ticket-title': ['19px', { lineHeight: '1.2', fontWeight: '800' }],
      'ticket-desc': ['14px', { lineHeight: '1.25', fontWeight: '700' }],
      'ticket-caption': ['12px', '1'],
      'ticket-amount': ['20px', '1'],
      'ticket-subtotal': ['20px', { lineHeight: '1', fontWeight: '800' }],
      'ticket-qty': ['18px', '1'],
    },
    borderRadius: {
      'ticket-step': '9999px',
    },
  },
}
